import React, { useState, useEffect, useCallback } from "react";
import { Input } from "antd";
import { debounce } from "../utils/mediaUtils";

const { Search } = Input;

const SearchBar = ({ onSearch, searchText }) => {
  const [localValue, setLocalValue] = useState(searchText || "");

  // Create debounced search function
  const debouncedSearch = useCallback(
    debounce((value) => {
      onSearch(value);
    }, 300),
    [onSearch]
  );

  // Update local value when searchText prop changes
  useEffect(() => {
    setLocalValue(searchText || "");
  }, [searchText]);

  const handleChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);
    debouncedSearch(value);
  };

  const handleSearch = (value) => {
    setLocalValue(value);
    onSearch(value); // Immediate search on enter/search button
  };

  return (
    <Search
      placeholder="Search names, types, dimensions, dates..."
      value={localValue}
      onChange={handleChange}
      onSearch={handleSearch}
      allowClear
      style={{ marginBottom: 16, width: 300 }}
    />
  );
};

export default SearchBar;
